module.exports = __webpack_public_path__ + "static/media/Picture10.04c28e21.jpg";